
import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";
import { Row, Col, Table, Input, Button, notification,Pagination } from 'antd';
import '../user/userList/userList.css'
import { SpinnerDotted } from 'spinners-react';
import OperatorForm from "./operatorForm";
import EditOperatorDetail from "./editOperatorDetail";
// import 'bootstrap/dist/css/bootstrap.min.css'


function UserList() {
    const [operatorList, setOperatorList] = useState("");
    const [step, setStep] = useState(0);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [id, setId] = useState(false);

    function changeState(newUserList){
        setOperatorList(newUserList)
    }

    const GreenNotification = (text) => {
        notification.open({
            message: "موفقیت",
            description: text,
            style: {
                background: "#43a047",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    useEffect( () => {
     
        Axios.get(`${Api}operator-list-panel?page=${pageNumber}&size=20&search=${search}`
        )
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    setStep(1)
                    setOperatorList(data.data.data);
                }

            })
            .catch((error) => {
            });
    }, [pageNumber]);


    const searching = () => {
        if (search.length !== 0) {
            Axios.get(`${Api}operator-list-panel?search=${search}&size=20`)
                .then((data) => {
                    if (data.statusCode === 200 || data.statusCode === 201) {

                        setStep(1);
                        setOperatorList(data.data.data);
                    }

                })
                .catch((error) => {
                    RedNotification("مشکلی در اتصال به سرور به وجود آمده است‌ !")
                });
        } else {
            RedNotification("برای جستجو ابتدا باید نام اپراتور را وارد نمایید")
        }
    }
    //
    // const roleManager = (role) => {
    //     switch (role) {
    //         case 1: return "مدیر"
    //         case 2: return "اپراتور"
    //         case 3: return "مشتری"
    //     }
    // }

    const columns = [
        {
            title: 'شناسه',
            dataIndex: "id",

        },
        {
            title: 'نام کاربری',
            dataIndex: 'username',

        },
        {
            title: 'نام',
            render: e => {

               return  e.first_name !== ""? <p>{e.first_name}</p>: <p>....</p>
            }

        },

        {
            title: 'نام خانوادگی',
            render: e => {

                return  e.last_name !== ""? <p>{e.last_name}</p>: <p>....</p>
            }

        },
        {
            title: 'موبايل',
            render: e => {
                return  e.mobile !== "" && e.mobile !== null? <p>{e.mobile}</p>: <p>....</p>
            }
        },


        // {
        //     title: 'عمليات',
        //     render: (e) => {
        //         return  <Button type="primary" onClick={async () =>{
        //             await setId(e.id);
        //             await setStep(3);
        //
        //         }
        //         }>عملیات</Button>
        //
        //     }
        //
        // },
    ];


    switch (step) {
        case 0:
            return <Row style={{ width: '100', justifyContent: 'center' }}>
                <SpinnerDotted size={89} thickness={180} speed={92} color="rgba(0, 0, 0, 0.85)" style={{ marginTop: '100px' }} />
            </Row>

        case 1:
            return (
                operatorList
                    ? <>
                        <Row style={{ background: 'white', marginBottom: '10px' }}>
                            <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} >
                                <Input
                                    onChange={(e) => { setSearch(e.target.value) }}
                                    id="userSerachInput"
                                    placeholder='برای جستجو نام اپراتور را وارد نمایید...'
                                />
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} >
                                <Button onClick={searching} id='userSearchButton'>جستجوی اپراتور</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button type="primary" onClick={() =>{
                                    setStep(2);
                                }} style={{fontSize: "15px", fontFamily: "iranSansBold"}}>افزودن اپراتور</Button>
                            </Col>
                        </Row>

                        <Table id='userTableList' columns={columns} dataSource={operatorList} pagination={false} />
                        <Row style={{width:'100%',justifyContent:'center'}}>
                            <Pagination
                                style={{direction:'ltr',marginTop:"20px"}}
                                current={pageNumber}
                                total={totalPage * 10}
                                pageSize={10}
                                onChange={
                                    (e)=>{
                                        setPageNumber(e)
                                    }
                                } />
                        </Row>

                    </>
                    :
                    <>
                        <p className='orderColumeText' >كاربري در حال حاضر براي نمايش وجود ندارد</p>
                    </>
            )

        case 2:
            return <>
                <OperatorForm setStep={setStep} setOperatorList={setOperatorList} pageNumber={pageNumber}/>
            </>

        case 3:
            return <EditOperatorDetail setStep={setStep} setOperatorList={setOperatorList} pageNumber={pageNumber} id={id}/>
    }
}
export default UserList;

